<template>
    <div class="workload-summary-wrapper">
        <MetricCard
            title="Open Assignments within SLA"
            :value="localOpenTotal.value"
            :change-text="localOpenTotal.changeText"
            :has-change="localOpenTotal.hasChange"
            :is-positive="localOpenTotal.isPositive"
            :is-good-change="localOpenTotal.isGoodChange"
        />

        <MetricCard
            title="Open Assignments at Risk"
            :value="localOpenAtRisk.value"
            :change-text="localOpenAtRisk.changeText"
            :has-change="localOpenAtRisk.hasChange"
            :is-positive="localOpenAtRisk.isPositive"
            :is-good-change="localOpenAtRisk.isGoodChange"
        />

        <MetricCard
            title="Open Breached Assignments"
            :value="localOpenBreached.value"
            :change-text="localOpenBreached.changeText"
            :has-change="localOpenBreached.hasChange"
            :is-positive="localOpenBreached.isPositive"
            :is-good-change="localOpenBreached.isGoodChange"
        />

        <MetricCard
            title="Total Completion"
            :value="localTotalCompletion.value"
            :change-text="localTotalCompletion.changeText"
            :has-change="localTotalCompletion.hasChange"
            :is-positive="localTotalCompletion.isPositive"
            :is-good-change="localTotalCompletion.isGoodChange"
        />

        <MetricCard
            title="Completion Rate"
            :value="localCompletionRatePerHour.value"
            :change-text="localCompletionRatePerHour.changeText"
            :has-change="false"
        />
    </div>
</template>

<script setup lang="ts">
import MetricCard from '@/pages/OperationsInsights/components/MetricCard.vue';
import { computed } from 'vue';
import { AssignmentSummariesComponentData } from '@/pages/OperationsInsights/composables/transformations/tfAssignmentSummariesData';

interface Props {
  assignmentSummariesData: AssignmentSummariesComponentData;
}

const props = withDefaults(defineProps<Props>(), {});
const defaultSummaryObj = {
    value: 0, changeText: '', hasChange: false, isPositive: false, isGoodChange: false
};

const localOpenTotal = computed(() => {
    return props.assignmentSummariesData?.openAssignmentTotalSM ?? defaultSummaryObj;
});

const localOpenAtRisk = computed(() => {
    return props.assignmentSummariesData?.openAssignmentAtRiskSM ?? defaultSummaryObj;
});

const localOpenBreached = computed(() => {
    return props.assignmentSummariesData?.openAssignmentBreachedSM ?? defaultSummaryObj;
});

const localTotalCompletion = computed(() => {
    return props.assignmentSummariesData?.totalCompletedCount ?? defaultSummaryObj;
});

const localCompletionRatePerHour = computed(() => {
    // TODO here
    return props.assignmentSummariesData?.completedAssignmentRateSM ?? defaultSummaryObj;
});

</script>
